import React from 'react';
import {NewsItemSidebarOtherNewsThumb} from "./NewsItemSidebarOtherNewsThumb";
import {NewsItemSidebarTags} from "./NewsItemSidebarTags";
import PropTypes from "prop-types";


export const NewsItemSideBar = ({isLoading, post, other}) => {

    return (
        <>
            <p style={{marginTop: "25px"}}>&nbsp;</p>
            {!isLoading && other.length > 0 && <NewsItemSidebarOtherNewsThumb other={other}/>}
            {!isLoading && post.tags?.length > 0 && <NewsItemSidebarTags post={post}/>}
        </>
    )
}

NewsItemSideBar.propTypes = {
    isLoading: PropTypes.bool,
    post: PropTypes.object,
    other: PropTypes.array
}